module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "mtbs-burn-severity--dataset-cover.13ecbe43.jpg";